// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = undefined;globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";globalThis["_sentryAssetPrefix"] = undefined;globalThis["_sentryExperimentalThirdPartyOriginStackFrames"] = undefined;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/:lang\",\"regex\":\"^/([^/]+)$\",\"paramNames\":[\"lang\"]},{\"path\":\"/:lang/game/:gameName\",\"regex\":\"^/([^/]+)/game/([^/]+)$\",\"paramNames\":[\"lang\",\"gameName\"]},{\"path\":\"/:lang/game/:gameName/:gameCode\",\"regex\":\"^/([^/]+)/game/([^/]+)/([^/]+)$\",\"paramNames\":[\"lang\",\"gameName\",\"gameCode\"]},{\"path\":\"/:lang/games\",\"regex\":\"^/([^/]+)/games$\",\"paramNames\":[\"lang\"]},{\"path\":\"/:lang/my-favourites\",\"regex\":\"^/([^/]+)/my-favourites$\",\"paramNames\":[\"lang\"]},{\"path\":\"/:lang/tags\",\"regex\":\"^/([^/]+)/tags$\",\"paramNames\":[\"lang\"]},{\"path\":\"/:lang/tags/:tagName/:tagId\",\"regex\":\"^/([^/]+)/tags/([^/]+)/([^/]+)$\",\"paramNames\":[\"lang\",\"tagName\",\"tagId\"]},{\"path\":\"/:lang/intro\",\"regex\":\"^/([^/]+)/intro$\",\"paramNames\":[\"lang\"]}],\"staticRoutes\":[{\"path\":\"/incorrect-property-id\"},{\"path\":\"/login\"},{\"path\":\"/simple-game\"}]}";import * as Sentry from '@sentry/nextjs'

Sentry.init({
  dsn: 'https://a2bc7649b367dfd09421dcc629e8195c@o4509682049351680.ingest.de.sentry.io/4509682053414992',

  // Only capture errors from specific domain
  allowUrls: [/https?:\/\/c7qsihc2r\.play\.gamezop\.com/, /https?:\/\/staging1\.gamezop\.com/],

  // Add optional integrations for additional features
  integrations: [
    Sentry.dedupeIntegration(),
    Sentry.browserTracingIntegration(),
    Sentry.contextLinesIntegration(),
    Sentry.browserSessionIntegration(),
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
    Sentry.browserApiErrorsIntegration({
      setTimeout: true,
      setInterval: true,
      requestAnimationFrame: true,
      XMLHttpRequest: true,
      eventTarget: true,
      unregisterOriginalCallbacks: true,
    }),
    Sentry.breadcrumbsIntegration({
      console: true,
      dom: true,
      fetch: true,
      history: true,
      xhr: true,
    }),
  ],

  // Define how likely Replay events are sampled.
  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,

  // Define how likely Replay events are sampled when an error occurs.
  replaysOnErrorSampleRate: 1.0,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: process.env.NODE_ENV !== 'production',
})

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart
